module.exports =
  controller: require('./index.ctrl')
  template: require('./index.pug')()
